import { z } from "@/zod";
import { readStore } from "./store";

export const projectStore = z.object({
  id: z.string().length(26),
  project_id: z.string().length(26),
  name: z.string().min(1),
  client_store_number: z.string().min(1),
  assigned_period_count: z.number().min(0),
  ...readStore.unwrap().omit({
    id: true,
    name: true,
    ref_number: true,
    client_store_number: true,
    shopping_center: true,
    notes: true,
    province: true,
    province_id: true,
    latitude: true,
    longitude: true,
  }).shape,
});

export const displayProjectStore = projectStore
  .omit({
    assigned_period_count: true,
  })
  .readonly();

export const readProjectStore = projectStore.readonly();

export const writeProjectStore = z.object({
  add: z.array(z.string().length(26)),
  delete: z.array(z.string().length(26)),
});
